import { DOMOutputSpecArray, MarkSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../../editor/types';
import { MarkName } from '../../../schema/marks';

export class UnderlineMark implements MarkSpec {
  public static readonly markName = MarkName.Underline;
  public parseDOM = [{ tag: 'u' }, { tag: 'underline' }, { style: 'text-decoration=underline' }];
  public toDOM(): DOMOutputSpecArray {
    return ['u', 0];
  }
}

export type UnderlineSchema = RtSchemaType<any, typeof UnderlineMark>;
